import * as React from "react";
import { NavLink } from "react-router-dom";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { ChiamaAPI, BottoneAPI, Trad, BaseComponent, Tipo, Mandanti, TipoCampoHTML, BancaDatiGare } from "../components/";
import {
    TipoCampoStringa,
    TipoCampoTesto,
    TipoCampoData,
    TipoCampoImporto,
    TipoCampoPercentuale,
    TipoCampoTipo,
    Contesto,
    CoAssicurazione,
    CampoData,
    Deroga,
    CheckListFile,
    TipoCampoCheckBox
} from "../components/";
import moment from "moment";
import { CData } from "../Data";
import ChiamaWeb, { CChiamaWebParametri } from "../ChiamaWeb";

interface IFidePolizzaState {
    Dato: Dati.CRisAPIDatoTipiInfo_Polizza;
    DatoFidePolizza: any;
    in1: string;
    in1Abl: boolean;
    in2: string;
    in2Abl: boolean;
    in3: string;
    in3Abl: boolean;
    in4: string;
    in4Abl: boolean;
    Parametri: Dati.TListaParametri;
    ListaCampiDeroga: Dati.TListaParametriDeroga;
    BinderProdotto: string;
    ForceLegalInterest: boolean;
}

export class FidePolizza extends BaseComponent<Glob.IRouteGlobaleProps, IFidePolizzaState> {
    private ID_Anag: number;
    private ID_Polizza: number = 0;

    private _RichiestaCasella: string = "";
    private _Cifra1: string = "0";
    private _Cifra2: string = "0";
    private _DisabilitaSelezionaProdotto: boolean = false;
    private _Limiti: Dati.Dictionary<number> = {};

    private _LimitiDeroga: Dati.Dictionary<any> = {};

    private _ImportoGarantitoMAXAffidamento: number = 0;
    private _ImportoGarantitoMAXBinder: number = 0;
    private _RiduzioneSommaGarantita?: number = undefined;

    private _NumeroBack: number = 0;

    private _URLInfoPolizzaBase: string = "/api/polizza/GetInfoPolizza?ID_TipoProdotto=";
    private _URLInfoPolizza: string = this._URLInfoPolizzaBase + "0";
    private _URLLimiteImportoGarantitoBase: string =
        "/api/polizza/GetLimiteImportoGarantito?id_AnagA=" + (this.props.match.params as any).ID_Anag + "&id_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento;
    private _URLLimiteImportoGarantito: string = this._URLLimiteImportoGarantitoBase + "&id_Polizza=" + (this.props.match.params as any).ID_Polizza + "&dataEffetto=";
    private _URLLimiteImportoGarantitoDeroga: string = "/api/deroga/GetLimitiDeroga?ID_Deroga=" + (this.props.match.params as any).ID_Polizza + "&ID_TipoDerogaStato=" + Glob.Tipi_DR_Approvata;
    private _URLBinderProdottoBase: string = "/api/polizza/GetFideBinderProdotto";
    private _URLBinderProdotto: string = "";

    private _DataEffettoModificabile: boolean = true;
    private _DataFineModificabile: boolean = true;
    private _TestoModificabile: boolean = true;
    
    private _Incremento: number = 1;
    private _AggiornaBancaDatiGare: number = 1;

    private _PresenzaProroghe: boolean = false;

    public constructor(props: any) {
        super(props);
        this.ID_Anag = (this.props.match.params as any).ID_Anag;
        this.ID_Polizza = (this.props.match.params as any).ID_Polizza;
        let dato: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
        dato.Dato.ID_AnagContraente = this.ID_Anag; //il contraente è sempre lo stesso dell'anagrafica di cui stiamo vedendo l'affidamento
        this.state = {
            Dato: dato,
            DatoFidePolizza: {}, //new DatiFide.CDatiFidePolizza(),
            in1: "",
            in1Abl: true,
            in2: "",
            in2Abl: true,
            in3: "",
            in3Abl: true,
            in4: "",
            in4Abl: true,
            Parametri: {},
            ListaCampiDeroga: {},
            BinderProdotto: "",
            ForceLegalInterest: false
        };

        this.GetDatiCambiati = this.GetDatiCambiati.bind(this);
        this.NumeroBack = this.NumeroBack.bind(this);
        this.OnBlurImporti = this.OnBlurImporti.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnChangeDataEffetto = this.OnChangeDataEffetto.bind(this);
        this.OnChangeDataPresentazione = this.OnChangeDataPresentazione.bind(this);
        this.OnChangeDataSvincolo = this.OnChangeDataSvincolo.bind(this);
        this.OnChangeDeroga = this.OnChangeDeroga.bind(this);
        this.OnChangeDurata = this.OnChangeDurata.bind(this);
        this.OnChangeImporti = this.OnChangeImporti.bind(this);
        this.OnChangeImportoComplessivo = this.OnChangeImportoComplessivo.bind(this);
        this.OnChangeProroghe = this.OnChangeProroghe.bind(this);
        this.OnChangeImportoInteresseLegale = this.OnChangeImportoInteresseLegale.bind(this);
        this.OnChangeTassoInteresseLegale = this.OnChangeTassoInteresseLegale.bind(this);
        this.OnClickCalcola = this.OnClickCalcola.bind(this);
        this.OnClickEstraiDati = this.OnClickEstraiDati.bind(this);
        this.OnClickSalva = this.OnClickSalva.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnInvioCalcola = this.OnInvioCalcola.bind(this);
        this.OnInvioSalva = this.OnInvioSalva.bind(this);
        this.OnListaCampi = this.OnListaCampi.bind(this);
        this.OnModificaURL = this.OnModificaURL.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnRisDatiPolizzaNuova = this.OnRisDatiPolizzaNuova.bind(this);
        this.SettaDatiSalvati = this.SettaDatiSalvati.bind(this);
        this.UtilizzaBancaDatiGare = this.UtilizzaBancaDatiGare.bind(this);

        window.onpopstate = this.NumeroBack;

        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = 24;
        M.VariabiliMenu = {
            ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString()
        };
        this.props.SetMenu(M);

        this.SettaDatiSalvati();
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        return false;
    }

    private OnChangeDeroga(e: React.FormEvent<any>, tipo: string, verso: string) {
        let listaCampiDeroga: Dati.TListaParametriDeroga = this.state.ListaCampiDeroga;
        if (e.currentTarget.checked) {
            listaCampiDeroga[e.currentTarget.value] = new Dati.CTipoCampoDeroga();
            listaCampiDeroga[e.currentTarget.value].Tipo = tipo;
            listaCampiDeroga[e.currentTarget.value].Verso = verso;
        } else {
            listaCampiDeroga = {};
            for (var I in this.state.ListaCampiDeroga) {
                if (I != e.currentTarget.value) listaCampiDeroga[I] = this.state.ListaCampiDeroga[I];
            }
        }

        this.setState({ ListaCampiDeroga: listaCampiDeroga });
    }

    public NumeroBack() {
        this._NumeroBack = this._NumeroBack + 1;
    }

    public componentDidMount() {
        window.onpopstate = this.NumeroBack;
    }

    private UtilizzaBancaDatiGare(dgc: Dati.CBancaDatiGare) {
        this.state.DatoFidePolizza.DataGara = dgc.DataGara || "";
        this.state.DatoFidePolizza.DataPresentazione = dgc.DataPresentazione || "";
        this.OnChange("Dato.DataEffetto", this.state.DatoFidePolizza.DataPresentazione);
        this.state.DatoFidePolizza.ImportoComplessivo = dgc.ImportoComplessivo || "";
        this.state.DatoFidePolizza.OggettoGaranzia = dgc.OggettoGaranzia || "";
        this.state.DatoFidePolizza.RibassoAsta = dgc.RibassoAsta || "0";
        this.setState({ DatoFidePolizza: this.state.DatoFidePolizza });
    }

    private _BottoneBancaGareVisibile = false;

    private DateModificabili(): void {
        this._DataEffettoModificabile = true;
        this._DataFineModificabile = true;
        this._TestoModificabile = true;
        
        for (var I in this.state.Dato.Info) {
            if (this.state.Dato.Info[I].Campo == "DataPresentazione") {
                this._DataEffettoModificabile = false;
            }
            if (this.state.Dato.Info[I].Campo == "DataSvincolo") {
                this._DataFineModificabile = false;
            }
        }

        let Sessione = Glob.GetSessione();
        const isCoverholder = Sessione.Gruppi.includes("7") || Sessione.Gruppi.includes("8")
            || Sessione.Gruppi.includes("9") || Sessione.Gruppi.includes("16");
        
        if (this.state.Dato.Dato.ID_TipoProdotto == Glob.TipoProdotto_ERinn && !isCoverholder)
        {
            this._TestoModificabile = false;
        }
    }

    private OnListaCampi(): React.ReactNode {
        let LC:any[] = [];

        let gruppo: string = "";
        let divGruppo: React.ReactNode[] = [];

        this.CalcolaLimti();

        this._BottoneBancaGareVisibile = false;

        for (var I in this.state.Dato.Info) {
            if (this.state.Dato.Info[I].Gruppo != gruppo) {
                if (gruppo != "") {
                    LC.push(
                        <div className="form-group kt-form login-form__group row align-items-center" key={I}>
                            {divGruppo}
                        </div>
                    );
                }

                gruppo = this.state.Dato.Info[I].Gruppo;

                divGruppo = [];
            }

            divGruppo.push(
                <div className="col-lg-6" key={I}>
                    <div>
                        {(() => {
                            let Valore: any;
                            for (var P in this.state.DatoFidePolizza) {
                                if (P == this.state.Dato.Info[I].Campo) {
                                    Valore = (this.state.DatoFidePolizza as any)[P];
                                    if (this.state.Dato.Dato.ID_TipoProdotto == Glob.TipoProdotto_ERinn &&
                                        this.state.Dato.Info[I].Campo == "TestoRichiesto" &&
                                        Valore === "") {
                                        let parametri: any = JSON.parse(this.state.Dato.Info[I].ParametriJSON);
                                        Valore = parametri.TestoRichiesto;
                                    }
                                }
                            }

                            switch (this.state.Dato.Info[I].ID_TipoCampo) {
                                case 1: //Intero
                                case 2: //Stringa
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "Durata":
                                            return (
                                                <TipoCampoStringa
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeDurata}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoStringa
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                case 11: //Testo
                                    return (
                                        <TipoCampoTesto
                                            DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                            Derogabile={this.state.Dato.Info[I].Derogabile}
                                            CampoDatabase={this.state.Dato.Info[I].Campo}
                                            Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={this.state.Dato.Info[I]}
                                            OnChange={e => this.OnChange(e)}
                                            Richiesto={this.state.Dato.Info[I].Richiesto}
                                            OnChangeDeroga={this.OnChangeDeroga}
                                        />
                                    );
                                case 12: //HTML
                                    return (
                                        <TipoCampoHTML
                                            DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                            Derogabile={this.state.Dato.Info[I].Derogabile}
                                            CampoDatabase={this.state.Dato.Info[I].Campo}
                                            Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={this.state.Dato.Info[I]}
                                            OnChange={this.OnChange}
                                            Richiesto={this.state.Dato.Info[I].Richiesto}
                                            OnChangeDeroga={this.OnChangeDeroga}
                                            CampoWordMassimoUnaTabella
                                            Scrittura={this._TestoModificabile}
                                        />
                                    );
                                case 9: //Importo
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "Imposte":
                                        case "ProroghePremioNetto":
                                        case "ProrogheImponibile":
                                        case "ProrogheImposte":
                                        case "ProroghePremioFinito":
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeImporti}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    OnBlur={this.OnBlurImporti}
                                                    Scrittura={false}
                                                />
                                            );
                                        case "Imponibile":
                                        case "DirittiEmissione":
                                        case "PremioFinito":
                                        case "PremioNetto":
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeImporti}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    OnBlur={this.OnBlurImporti}
                                                />
                                            );
                                        case "TotaleInteresseLegale":
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    Scrittura={false}
                                                />
                                            );
                                        case "ImportoInteresseLegale":
                                            return (
                                                <>
                                                    {Glob.AzioneAbilitata("ForzaInteresseLegale", Glob.Scrittura) && (
                                                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal">
                                                            {Trad.Trad("Force Legal Interest Amount")}
                                                            <input
                                                                name="ForceLegalInterest"
                                                                id="ForceLegalInterest"
                                                                value="ForceLegalInterest"
                                                                checked={this.state.ForceLegalInterest}
                                                                type="checkbox"
                                                                onChange={this.OnChange}
                                                            />
                                                            <span></span>
                                                        </label>
                                                    )}
                                                    <TipoCampoImporto
                                                        DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                        Derogabile={this.state.Dato.Info[I].Derogabile}
                                                        CampoDatabase={this.state.Dato.Info[I].Campo}
                                                        Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                        Valore={Valore}
                                                        InfoCampo={this.state.Dato.Info[I]}
                                                        OnChange={this.OnChangeImportoInteresseLegale}
                                                        Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                        Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                        Richiesto={this.state.Dato.Info[I].Richiesto}
                                                        OnChangeDeroga={this.OnChangeDeroga}
                                                        Scrittura={this.state.ForceLegalInterest}
                                                    />
                                                </>
                                            );
                                        case "ImportoComplessivo":
                                        case "ImportoComplessivoProvvisoria":
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeImportoComplessivo}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        case "ProrogheDirittiEmissione":
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeProroghe}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoImporto
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                case 5: //Checkbox
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "ImpegnoRilascio":
                                            if (Valore === "") {
                                                Valore = true;
                                                this.OnChange("DatoFidePolizza.ImpegnoRilascio", Valore);
                                            }
                                            return (
                                                <TipoCampoCheckBox
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoCheckBox
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                case 7: //Tipo
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "ID_AnagBeneficiario":
                                        case "ID_AnagBeneficiario2":
                                            return (
                                                <TipoCampoTipo
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChange}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    ComponenteDopoEtichetta={
                                                        <>
                                                            <a
                                                                href="/anagrafica/0"
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    this.ApriPopupBenefiario();
                                                                }}
                                                                className="arrow"
                                                            >
                                                                {" "}
                                                                <i className="fa fa-plus" />{" "}
                                                            </a>
                                                            <a href={"/anagrafica/" + Valore} className="kt-menu__link" target="_sef">
                                                                <i className="fa fa-search"></i>
                                                            </a>
                                                        </>
                                                    }
                                                />
                                            );
                                        case "ProrogheTipo":
                                            return (
                                                <TipoCampoTipo
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeProroghe}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoTipo
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChange}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                case 10: //Percentuale
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "Accessori":
                                            return (
                                                <TipoCampoPercentuale
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeImporti}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    OnBlur={this.OnBlurImporti}
                                                />
                                            );
                                        case "TassoInteresseLegale":
                                            return (
                                                <TipoCampoPercentuale
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeTassoInteresseLegale}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        case "ProrogheAccessori":
                                            this._PresenzaProroghe = true;
                                            return (
                                                <TipoCampoPercentuale
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    Scrittura={false}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoPercentuale
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Valore}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={e => this.OnChange(e)}
                                                    Massimo={this._Limiti[this.state.Dato.Info[I].Campo + "MAX"]}
                                                    Minimo={this._Limiti[this.state.Dato.Info[I].Campo + "MIN"]}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                case 3: //Data
                                    switch (this.state.Dato.Info[I].Campo) {
                                        case "DataPresentazione":
                                            return (
                                                <TipoCampoData
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Glob.DataValore(Valore)}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeDataPresentazione}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        case "DataSvincolo":
                                            return (
                                                <TipoCampoData
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Glob.DataValore(Valore)}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChangeDataSvincolo}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                        case "ProrogheDa":
                                            this._PresenzaProroghe = true;
                                            return (
                                                <TipoCampoData
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Glob.DataValore(Valore)}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChange}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                    Scrittura={false}
                                                />
                                            );
                                        default:
                                            return (
                                                <TipoCampoData
                                                    DerogaVerso={this.state.Dato.Info[I].DerogaVerso}
                                                    Derogabile={this.state.Dato.Info[I].Derogabile}
                                                    CampoDatabase={this.state.Dato.Info[I].Campo}
                                                    Campo={"DatoFidePolizza." + this.state.Dato.Info[I].Campo}
                                                    Valore={Glob.DataValore(Valore)}
                                                    InfoCampo={this.state.Dato.Info[I]}
                                                    OnChange={this.OnChange}
                                                    Richiesto={this.state.Dato.Info[I].Richiesto}
                                                    OnChangeDeroga={this.OnChangeDeroga}
                                                />
                                            );
                                    }
                                default:
                                    return this.state.Dato.Info[I].Campo + " [" + this.state.Dato.Info[I].ID_TipoCampo + "]";
                            }
                        })()}
                    </div>
                </div>
            );

            if (this.state.Dato.Info[I].Campo == "CIG") {
                this._BottoneBancaGareVisibile = true;
            }
        }
        LC.push(
            <div className="form-group kt-form login-form__group row" key={999}>
                {divGruppo}
            </div>
        );

        return LC;
    }

    private OnBlurImporti(e: React.FormEvent<any> | string, valore: any) {
        let PremioNetto: number = this.state.DatoFidePolizza.PremioNetto;
        if (PremioNetto < this._Limiti["PremioNettoMIN"]) {
            PremioNetto = this._Limiti["PremioNettoMIN"];
            this.state.DatoFidePolizza.PremioNetto = PremioNetto;
            this.state.DatoFidePolizza.Imponibile = PremioNetto + (this.state.DatoFidePolizza.Accessori * PremioNetto) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
            this.state.DatoFidePolizza.Imposte = this.state.DatoFidePolizza.Imponibile * this.Tasse;
            this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + this.state.DatoFidePolizza.Imposte;

            this.setState({ DatoFidePolizza: this.state.DatoFidePolizza }, () => this.RicalcolaProroghe());
            Glob.InfoModaleWarning("WARNING", "PremioImpostatoInferioreAlPremioMinimo");
        } else if (PremioNetto > this._Limiti["PremioNettoMAX"]) {
            PremioNetto = this._Limiti["PremioNettoMAX"];
            this.state.DatoFidePolizza.PremioNetto = PremioNetto;
            this.state.DatoFidePolizza.Imponibile = PremioNetto + (this.state.DatoFidePolizza.Accessori * PremioNetto) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
            this.state.DatoFidePolizza.Imposte = this.state.DatoFidePolizza.Imponibile * this.Tasse;
            this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + this.state.DatoFidePolizza.Imposte;

            this.setState({ DatoFidePolizza: this.state.DatoFidePolizza }, () => this.RicalcolaProroghe());
            Glob.InfoModaleWarning("WARNING", "PremioImpostatoSuperioreAlLimite");
        } else {
            let Imponibile: number = this.state.DatoFidePolizza.Imponibile;
            let ImponibileCalcolato: number =
                this.state.DatoFidePolizza.PremioNetto + (this.state.DatoFidePolizza.PremioNetto * this.state.DatoFidePolizza.Accessori) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
            if (Math.abs(Imponibile - ImponibileCalcolato) >= 0.01) {
                Glob.InfoModaleWarning(
                    "WARNING",
                    Trad.TradParam("ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}", [ImponibileCalcolato, Imponibile, Imponibile - ImponibileCalcolato])
                );
            }
            this.RicalcolaProroghe();
        }
    }

    private RicalcolaProroghe() {
        if (this._PresenzaProroghe) {
            const Param: CChiamaWebParametri = {
                URL: "/api/polizza/FideCalcolaProroghe",
                Metodo: "POST",
                OnInvio: this.OnInvioCalcola,
                OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPIDatoTipiInfo_Polizza) => {
                    if (dati.Errore) {
                        Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
                    } else {
                        let DatoFidePolizza = JSON.parse(dati.Dato.DatiPolizza);
                        this._Limiti["PremioNettoMAX"] = DatoFidePolizza.PremioFinito * 2;
                        this.AggiornaRichiesteCartaServizi(dati);
                        this.setState({
                            Dato: dati,
                            DatoFidePolizza: DatoFidePolizza
                        });
                        //Glob.InfoModaleSuccess("Info", Trad.Trad("Premio calcolato correttamente"));
                    }
                }
            };
            ChiamaWeb.ChiamaWeb(Param);
        }
    }

    private OnChangeImportoInteresseLegale(e: React.FormEvent<any>) {
        this.state.DatoFidePolizza.TotaleInteresseLegale = Number(e.currentTarget.value) + this.state.DatoFidePolizza.ImportoGarantito;
        this.setState({ DatoFidePolizza: this.state.DatoFidePolizza });

        this.OnChange(e);
    }

    private OnChangeTassoInteresseLegale(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e !== "string") {
            this.state.DatoFidePolizza.ImportoInteresseLegale = (Number(e.currentTarget.value) * this.state.DatoFidePolizza.ImportoGarantito) / 100;
            this.state.DatoFidePolizza.TotaleInteresseLegale = this.state.DatoFidePolizza.ImportoInteresseLegale + this.state.DatoFidePolizza.ImportoGarantito;
            this.setState({
                DatoFidePolizza: this.state.DatoFidePolizza,
                ForceLegalInterest: false
            });
        }
        this.OnChange(e, valore);
    }

    private OnChangeDurata(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e !== "string") {
            let Durata: number = Number(e.currentTarget.value);
            if (this.state.DatoFidePolizza.DataPresentazione != undefined && this.state.DatoFidePolizza.DataSvincolo != undefined) {
                let DataPresentazione: Date = moment(this.state.DatoFidePolizza.DataPresentazione).toDate();
                let DataSvincolo: Date = new CData(DataPresentazione, true).AddGiorni(Durata).Data;

                this.OnChange("DatoFidePolizza.DataSvincolo", DataSvincolo);
                this.OnChange("Dato.DataFine", DataSvincolo);
                this.OnChange("Dato.DataEffetto", DataPresentazione);
            } else if (this.state.Dato.Dato.DataEffetto != undefined && this.state.DatoFidePolizza.DataSvincolo != undefined) {
                let DataSvincolo: Date = new CData(moment(this.state.Dato.Dato.DataEffetto).toDate(), true).AddGiorni(Durata).Data;

                this.OnChange("DatoFidePolizza.DataSvincolo", DataSvincolo);
                this.OnChange("Dato.DataFine", DataSvincolo);
            }
        }
        this.OnChange(e, valore);
    }

    private OnChangeDataPresentazione(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e == "string") {
            if (this.state.DatoFidePolizza.DataPresentazione != undefined && this.state.DatoFidePolizza.DataSvincolo != undefined && this.state.DatoFidePolizza.Durata != undefined) {
                let DataPresentazione: moment.Moment = moment(valore);
                this.OnChange("Dato.DataEffetto", DataPresentazione.toDate());

                let Durata: number = Number(this.state.DatoFidePolizza.Durata);
                let DataSvincolo: Date = new CData(DataPresentazione.toDate(), true).AddGiorni(Durata).Data;

                this.OnChange("Dato.DataFine", DataSvincolo);
                this.OnChange("DatoFidePolizza.DataSvincolo", DataSvincolo);
            }
        }
        this.OnChange(e, valore);
    }

    private OnChangeDataEffetto(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e == "string") {
            if (this.state.DatoFidePolizza.DataSvincolo != undefined && this.state.DatoFidePolizza.Durata != undefined) {
                let DataEffetto: moment.Moment = moment(valore);
                let DataSvincolo: moment.Moment = moment(this.state.DatoFidePolizza.DataSvincolo);
                if (DataEffetto.toDate() > DataSvincolo.toDate()) {
                    DataSvincolo = DataEffetto;
                    this.OnChange("Dato.DataFine", DataSvincolo.toDate());
                    this.OnChange("DatoFidePolizza.DataSvincolo", DataSvincolo.toDate());
                }

                let Durata: number = DataSvincolo.diff(DataEffetto, "days");

                this.OnChange("DatoFidePolizza.Durata", Durata);
            }
        }
        this.OnChange(e, valore);
    }

    private OnChangeDataSvincolo(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e == "string") {
            if (this.state.DatoFidePolizza.DataPresentazione != undefined && this.state.DatoFidePolizza.DataSvincolo != undefined && this.state.DatoFidePolizza.Durata != undefined) {
                let DataPresentazione: moment.Moment = moment(this.state.DatoFidePolizza.DataPresentazione);
                let DataSvincolo: moment.Moment = moment(valore);

                if (DataPresentazione.toDate() > DataSvincolo.toDate()) {
                    DataPresentazione = DataSvincolo;
                    this.OnChange("DatoFidePolizza.DataPresentazione", DataPresentazione.toDate());
                }

                let Durata: number = DataSvincolo.diff(DataPresentazione, "days");

                this.OnChange("DatoFidePolizza.Durata", Durata);
                this.OnChange("Dato.DataFine", DataSvincolo.toDate());
                this.OnChange("Dato.DataEffetto", DataPresentazione.toDate());
            } else if (this.state.Dato.Dato.DataEffetto != undefined && this.state.DatoFidePolizza.DataSvincolo != undefined && this.state.DatoFidePolizza.Durata != undefined) {
                let DataEffetto: moment.Moment = moment(this.state.Dato.Dato.DataEffetto);
                let DataSvincolo: moment.Moment = moment(valore);

                if (DataEffetto.toDate() > DataSvincolo.toDate()) {
                    DataEffetto = DataSvincolo;
                    this.OnChange("Dato.DataEffetto", DataEffetto.toDate());
                }

                let Durata: number = DataSvincolo.diff(DataEffetto, "days");

                this.OnChange("DatoFidePolizza.Durata", Durata);
                this.OnChange("Dato.DataFine", DataSvincolo.toDate());
            }
        }
        this.OnChange(e, valore);
    }

    private OnChangeProroghe(e: React.FormEvent<any> | string, valore: any) {
        this.OnChange(e, valore);
        this.OnBlurImporti(e, valore);
    }

    private OnChangeImportoComplessivo(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e !== "string") {
            if (this._RiduzioneSommaGarantita != undefined) {
                let ImportoGarantito: number = (Number(e.currentTarget.value) * this._RiduzioneSommaGarantita) / 100;
                if (ImportoGarantito > this._Limiti["ImportoGarantitoMAX"]) {
                    ImportoGarantito = this._Limiti["ImportoGarantitoMAX"];
                }
                this.OnChange("DatoFidePolizza.ImportoGarantito", ImportoGarantito);
            }
        }
        this.OnChange(e, valore);
    }

    private readonly Tasse: number = 0.125;

    private OnChangeImporti(e: React.FormEvent<any> | string, valore: any) {
        if (typeof e !== "string") {
            switch (e.currentTarget.name) {
                case "DatoFidePolizza.PremioNetto":
                    this.state.DatoFidePolizza.Imponibile =
                        Number(e.currentTarget.value) + (this.state.DatoFidePolizza.Accessori * Number(e.currentTarget.value)) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
                    this.state.DatoFidePolizza.Imposte = this.state.DatoFidePolizza.Imponibile * this.Tasse;
                    this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + this.state.DatoFidePolizza.Imposte;
                    break;
                case "DatoFidePolizza.Accessori":
                    this.state.DatoFidePolizza.Imponibile =
                        this.state.DatoFidePolizza.PremioNetto + (Number(e.currentTarget.value) * this.state.DatoFidePolizza.PremioNetto) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
                    this.state.DatoFidePolizza.Imposte = this.state.DatoFidePolizza.Imponibile * this.Tasse;
                    this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + this.state.DatoFidePolizza.Imposte;
                    break;
                case "DatoFidePolizza.DirittiEmissione":
                    this.state.DatoFidePolizza.Imponibile =
                        this.state.DatoFidePolizza.PremioNetto + (this.state.DatoFidePolizza.Accessori * this.state.DatoFidePolizza.PremioNetto) / 100 + Number(e.currentTarget.value);
                    this.state.DatoFidePolizza.Imposte = this.state.DatoFidePolizza.Imponibile * this.Tasse;
                    this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + this.state.DatoFidePolizza.Imposte;
                    break;
                case "DatoFidePolizza.Imponibile":
                    this.state.DatoFidePolizza.Imposte = Number(e.currentTarget.value) * this.Tasse;
                    this.state.DatoFidePolizza.PremioFinito = Number(e.currentTarget.value) + this.state.DatoFidePolizza.Imposte;
                    break;
                case "DatoFidePolizza.Imposte":
                    this.state.DatoFidePolizza.Imponibile = Number(e.currentTarget.value) / this.Tasse;
                    this.state.DatoFidePolizza.PremioFinito = this.state.DatoFidePolizza.Imponibile + Number(e.currentTarget.value);
                    break;
                case "DatoFidePolizza.PremioFinito":
                    this.state.DatoFidePolizza.Imposte = Number(e.currentTarget.value) / (1 / this.Tasse + 1);
                    this.state.DatoFidePolizza.Imponibile = Number(e.currentTarget.value) / (1 + this.Tasse);
                    this.state.DatoFidePolizza.PremioNetto =
                        (this.state.DatoFidePolizza.Imponibile - this.state.DatoFidePolizza.DirittiEmissione) / ((100 + this.state.DatoFidePolizza.Accessori) / 100);
                    break;
            }
            this.setState({ DatoFidePolizza: this.state.DatoFidePolizza });
        }
        this.OnChange(e, valore);
    }

    private AbilitaCampiCartaServizi(campo: string) {
        switch (campo) {
            case "1":
                this.setState({ in1Abl: false });
                break;
            case "2":
                this.setState({ in2Abl: false });
                break;
            case "3":
                this.setState({ in3Abl: false });
                break;
            case "4":
                this.setState({ in4Abl: false });
                break;
        }
    }

    private InizializzaCampiCartaServizi() {
        this.setState({
            in1Abl: true,
            in2Abl: true,
            in3Abl: true,
            in4Abl: true
        });
    }

    private BloccoInput(blocco: boolean): string {
        if (blocco) {
            return " cartaservizibloccata";
        } else {
            return "";
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                this.OnModificaURL(undefined, dati.Dato.ID_TipoProdotto);

                this._URLLimiteImportoGarantito =
                    this._URLLimiteImportoGarantitoBase +
                    "&id_Polizza=" +
                    dati.Dato.ID_Polizza +
                    "&dataEffetto=" +
                    moment(this.state.Dato.Dato.DataEffetto).utc().format() +
                    "&id_TipoProdotto=" +
                    dati.Dato.ID_TipoProdotto;

                if (
                    dati.Tipi["BinderProdotto"].BinderProdotto.Valore != undefined &&
                    dati.Tipi["BinderProdotto"].BinderProdotto.Valore != null &&
                    dati.Tipi["BinderProdotto"].BinderProdotto.Valore != ""
                ) {
                    this.setState({
                        BinderProdotto: dati.Tipi["BinderProdotto"].BinderProdotto.Valore
                    });
                }

                this.AggiornaRichiesteCartaServizi(dati);
                this._DisabilitaSelezionaProdotto = true;
                if (dati.ID_Chiave > 0) {
                    //Controllo che la polizza non sia stata aggiornata con dei nuovi campi, quindi creo una classe con i campi configurati
                    //e la riempio con quelli che trovo all'interno dei dati JSON della polizza che mi arrivano da DB
                    let nuovaPolizza: any = Glob.CreaClassePolizzaFide(dati.Info);

                    let DatoPolizza: any = JSON.parse(dati.Dato.DatiPolizza);
                    for (let key in nuovaPolizza) {
                        if (DatoPolizza[key] != undefined) {
                            nuovaPolizza[key] = DatoPolizza[key];
                        }
                    }
                    this.setState({
                        Dato: dati,
                        DatoFidePolizza: nuovaPolizza
                    });
                    this.ID_Polizza = dati.ID_Chiave;
                } else {
                    this._DisabilitaSelezionaProdotto = false;
                }
            } else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
            this.ControlloEmissione();
        }
        return false;
    }

    private AggiornaRichiesteCartaServizi(dati: Dati.CRisAPIDatoTipiInfo_Polizza) {
        this.InizializzaCampiCartaServizi();
        if (dati.Tipi["RichiesteCartaServizi"].RichiestaCasella != undefined && dati.Tipi["RichiesteCartaServizi"].RichiestaCasella != null) {
            this._RichiestaCasella = dati.Tipi["RichiesteCartaServizi"].RichiestaCasella.Valore;
            this._Cifra1 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra1.Valore;
            this._Cifra2 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra2.Valore;
            this.AbilitaCampiCartaServizi(this._Cifra1);
            this.AbilitaCampiCartaServizi(this._Cifra2);
        }
    }

    private CoAssicurazioneSingola(binderProdotto: string) {
        if (binderProdotto != undefined && binderProdotto.length > 0) {
            let BP: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(binderProdotto);
            if (BP.length == 1) {
                let CoAss = new Dati.CDatoCoAssicurazione();
                CoAss.Delegataria = true;
                CoAss.Quota = 100;
                CoAss.ID_Anag = BP[0].ID_AnagCompagnia;
                CoAss.ID_Binder = BP[0].ID_Binder;
                CoAss.ID_BinderCompagnia = BP[0].ID_BinderCompagnia;
                return JSON.stringify([CoAss]);
            }
        }
        return "";
    }

    private OnRisBinderProdotto(sender: ChiamaAPI, dati: Dati.CRisAPISemplice<string>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.state.Dato.Dato.CoAssicurazioneJSON = this.CoAssicurazioneSingola(dati.Dato);
            this.setState({ BinderProdotto: dati.Dato, Dato: this.state.Dato });
        }
        return true;
    }

    private OnRisDatiPolizzaNuova(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.Dato.Dato.ID_Polizza == 0 && this.state.Dato.Dato.ID_TipoProdotto > 0) {
            let datiPolizzaVuota: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
            datiPolizzaVuota.Info = dati.Info;
            datiPolizzaVuota.Dato = this.state.Dato.Dato;

            let nuovaPolizza: any = Glob.CreaClassePolizzaFide(dati.Info);
            nuovaPolizza.LuogoEsecuzione = "Vedasi oggetto garanzia";
            if (
                this.state.Dato.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaLavori ||
                this.state.Dato.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaForniture ||
                this.state.Dato.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaServizi
            ) {
                nuovaPolizza.Durata = 180;
                nuovaPolizza.DataSvincolo = new CData(moment(this.state.Dato.Dato.DataEffetto).toDate(), true).AddGiorni(nuovaPolizza.Durata).Data;
                datiPolizzaVuota.Dato.DataFine = nuovaPolizza.DataSvincolo;
            }

            let DataSvincolo: Date = new CData(moment(this.state.Dato.Dato.DataEffetto).toDate(), true).AddGiorni(nuovaPolizza.Durata).Data;

            this.setState({ Dato: datiPolizzaVuota, DatoFidePolizza: nuovaPolizza }, () => {
                Glob.FermaCaricamento();
            });
        }
        return false;
    }

    private OnRisLimiteAffidamento(sender: ChiamaAPI, dati: Dati.CRisAPI_DatiLimitiBinder, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && !dati.Errore /*&& this.state.Dato.Dato.ID_TipoProdotto > 0*/) {
            this._ImportoGarantitoMAXAffidamento = dati.ImportoGarantito;
            this._RiduzioneSommaGarantita = dati.RiduzioneSommaGarantita;

            if (this._ImportoGarantitoMAXAffidamento < this._ImportoGarantitoMAXBinder) {
                this._Limiti["ImportoGarantitoMAX"] = this._ImportoGarantitoMAXAffidamento;
            } else {
                this._Limiti["ImportoGarantitoMAX"] = this._ImportoGarantitoMAXBinder;
            }
            if (this._LimitiDeroga["ImportoGarantitoMAX"] > this._Limiti["ImportoGarantitoMAX"]) {
                this._Limiti["ImportoGarantitoMAX"] = this._LimitiDeroga["ImportoGarantitoMAX"];
            }

            this._Limiti["ImportoGarantitoMIN"] = 0;
            this._Limiti["ImportoGarantitoNEUTRO"] = 0;

            this.forceUpdate();
        }

        return false;
    }

    private OnRisLimiteDeroga(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<Dati.CTipoCampoDeroga>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && !dati.Errore /*&& this.state.Dato.Dato.ID_TipoProdotto > 0*/) {
            for (var I in dati.Dati) {
                let indicatore: string = "";
                if (dati.Dati[I].Verso == ">") indicatore = "MAX";
                else indicatore = "MIN";

                switch (dati.Dati[I].Tipo) {
                    case "Importo":
                    case "Percentuale":
                        this._LimitiDeroga[I + indicatore] = Number(dati.Dati[I].Valore);
                        break;
                    case "Data":
                        this._LimitiDeroga[I + indicatore] = moment(dati.Dati[I].Valore).utc().format();
                        break;
                    case "Testo":
                        this._LimitiDeroga[I + indicatore] = dati.Dati[I].Valore.toString();
                        break;
                }

                if (dati.Dati[I].Verso == ">")
                    if (this._LimitiDeroga[I + indicatore] > this._Limiti[I + indicatore]) this._Limiti[I + indicatore] = this._LimitiDeroga[I + indicatore];
                    else if (this._LimitiDeroga[I + indicatore] < this._Limiti[I + indicatore]) this._Limiti[I + indicatore] = this._LimitiDeroga[I + indicatore];
            }
        }

        return false;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        this._AggiornaBancaDatiGare++;
        this.forceUpdate();
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            this._DisabilitaSelezionaProdotto = (this.state.Dato.Dato.ID_TipoProdotto.toString() || "") != "";
            this.ID_Polizza = dati.ID_Chiave;
            this.OnChange("Dato.ID_Polizza", this.ID_Polizza);
            this.OnChange("Dato.Polizza", dati.MessaggioTesto);
            this.OnChange("Dato.ContraenteATI", dati.MessaggioDati[0]);
            let salvati = this.state.Dato;
            salvati.Dato.ID_TipoFileRichiesto = dati.MessaggioDati[1];
            this.setState({ Dato: salvati });
            this.props.history.replace("/anagrafica/" + this.ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FidePolizza/" + this.ID_Polizza);
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Polizza salvata correttamente con ID: {1-S}", [this.ID_Polizza]));
        }
        this.SettaDatiSalvati();
    }

    private OnClickEmetti(sender: BottoneAPI, dati: Dati.CRisAPI) {
        //TODO Segnalato caso in cui il popup non appare nel caso di errore ValutazioneNonValida
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        } else {
            let app = this.state.Dato;
            app.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Emessa;
            app.Dato.Polizza = dati.MessaggioTesto;
            app.Dato.StatoPolizza = "Polizza emessa";
            this.setState({ Dato: app });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Polizza emessa correttamente"));
        }
    }

    private OnClickCalcola(sender: BottoneAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            let DatoFidePolizza = JSON.parse(dati.Dato.DatiPolizza);
            this._Limiti["PremioNettoMAX"] = DatoFidePolizza.PremioFinito * 2;
            this.AggiornaRichiesteCartaServizi(dati);
            this.setState({ Dato: dati, DatoFidePolizza: DatoFidePolizza });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Premio calcolato correttamente"));
        }
    }

    private OnClickEstraiDati(sender: BottoneAPI, dati: Dati.CRisAPIDato<Dati.CDatiANAC>) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.state.DatoFidePolizza.DataAggiudicazione = dati.Dato.DataAggiudicazione;
            this.state.DatoFidePolizza.DataPresentazione = dati.Dato.DataOfferta;
            this.state.DatoFidePolizza.ImportoGarantito = dati.Dato.ImportoAggiudicazione;
            this.state.DatoFidePolizza.ImportoComplessivo = dati.Dato.ImportoGara;
            this.state.DatoFidePolizza.OggettoGaranzia = dati.Dato.Oggetto;
            this.state.DatoFidePolizza.RibassoAsta = dati.Dato.Ribasso;
            this.setState({ DatoFidePolizza: this.state.DatoFidePolizza });
            Glob.InfoModaleSuccess("Info", Trad.Trad("DatiEstrattiCorrettamente"));
        }
    }

    private OnModificaURL(e: any, v: any): any {
        Glob.AvviaCaricamento(Trad.Trad("Caricamento dati polizza"));
        this._URLInfoPolizza = this._URLInfoPolizzaBase + String(v);
        this._URLBinderProdotto =
            this._URLBinderProdottoBase +
            "?id_FideAffidamento=" +
            (this.props.match.params as any).ID_FideAffidamento +
            "&id_TipoProdotto=" +
            String(v) +
            "&dataEffetto=" +
            moment(this.state.Dato.Dato.DataEffetto).utc().format();

        this._URLLimiteImportoGarantito =
            this._URLLimiteImportoGarantitoBase +
            "&id_Polizza=" +
            this.state.Dato.Dato.ID_Polizza +
            "&id_AnagPOS=" +
            this.state.Dato.Dato.ID_AnagPOS +
            "&dataEffetto=" +
            moment(this.state.Dato.Dato.DataEffetto).utc().format() +
            "&id_TipoProdotto=" +
            String(v);

        this.state.Dato.Dato.CoAssicurazioneJSON = "";
        this.state.Dato.Info = {};
        this.setState({ Dato: this.state.Dato });

        this._Incremento = this._Incremento + 1;
        return v;
    }

    private CalcolaLimti() {
        let CoAss: Dati.CDatoCoAssicurazione[] = [];
        try {
            if (this.state.Dato.Dato.CoAssicurazioneJSON.length > 0) {
                CoAss = JSON.parse(this.state.Dato.Dato.CoAssicurazioneJSON);
            }
        } catch {
            CoAss = [];
        }

        let BP: Dati.CDatoBinderProdottoCoAssicurazione[] = [];

        try {
            BP = JSON.parse(this.state.BinderProdotto);
        } catch {
            BP = [];
        }

        this._Limiti["DirittiEmissioneMAX"] = 0;
        this._Limiti["DirittiEmissioneMIN"] = 0;
        this._Limiti["DirittiEmissioneNEUTRO"] = 0;

        this._Limiti["AccessoriMAX"] = 0;
        this._Limiti["AccessoriMIN"] = 0;
        this._Limiti["AccessoriNEUTRO"] = 0;

        this._Limiti["PremioNettoMAX"] = 0;
        this._Limiti["PremioNettoMIN"] = 0;
        this._Limiti["PremioNettoNEUTRO"] = 0;

        this._Limiti["TassoMAX"] = 100;
        this._Limiti["TassoMIN"] = 0;
        this._Limiti["TassoNEUTRO"] = 0;

        this._ImportoGarantitoMAXBinder = 0;

        for (let x: number = 0; x < CoAss.length; x++) {
            for (let y: number = 0; y < BP.length; y++) {
                if (BP[y].ID_AnagCompagnia == CoAss[x].ID_Anag) {
                    this._Limiti["DirittiEmissioneMAX"] = this._Limiti["DirittiEmissioneMAX"] + (BP[y].LimiteDirittiFissi * CoAss[x].Quota) / 100;
                    this._Limiti["AccessoriMAX"] = this._Limiti["AccessoriMAX"] + (BP[y].LimiteAccessori * CoAss[x].Quota) / 100;
                    if (CoAss[x].Delegataria) {
                        this._Limiti["PremioNettoMIN"] = BP[y].PremioMinimo;
                        this._Limiti["TassoMIN"] = BP[y].TassoMin;
                    }
                    this._ImportoGarantitoMAXBinder = this._ImportoGarantitoMAXBinder + (BP[y].LimitePerSingoloProdotto * CoAss[x].Quota) / 100;
                }
            }
        }

        if (this._ImportoGarantitoMAXBinder < this._ImportoGarantitoMAXAffidamento) {
            this._Limiti["ImportoGarantitoMAX"] = this._ImportoGarantitoMAXBinder;
        } else {
            this._Limiti["ImportoGarantitoMAX"] = this._ImportoGarantitoMAXAffidamento;
        }

        for (var I in this._LimitiDeroga) {
            if (I.substr(I.length - 3, 3) == "MAX") {
                if (this._LimitiDeroga[I] > this._Limiti[I]) {
                    this._Limiti[I] = this._LimitiDeroga[I];
                }
            } else {
                if (this._LimitiDeroga[I] < this._Limiti[I]) {
                    this._Limiti[I] = this._LimitiDeroga[I];
                }
            }
        }

        this._Limiti["PremioNettoMAX"] = this._Limiti["PremioNettoMIN"] * 1000;
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        if (this.state.DatoFidePolizza.Imponibile != undefined) {
            let Imponibile: number = this.state.DatoFidePolizza.Imponibile;
            let ImponibileCalcolato: number =
                this.state.DatoFidePolizza.PremioNetto + (this.state.DatoFidePolizza.PremioNetto * this.state.DatoFidePolizza.Accessori) / 100 + this.state.DatoFidePolizza.DirittiEmissione;
            if (Math.abs(Imponibile - ImponibileCalcolato) >= 0.01) {
                Glob.InfoModaleWarning(
                    "WARNING",
                    Trad.TradParam("ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}", [ImponibileCalcolato, Imponibile, Imponibile - ImponibileCalcolato])
                );
                return false;
            }
        }

        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        Ingr.Dato = this.state.Dato.Dato;
        Ingr.Dato.ID_AnagContraente = this.ID_Anag;
        Ingr.Dato.ID_Polizza = this.ID_Polizza;
        Ingr.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Preventivo;
        Ingr.Dato.ID_TipoRamo = Glob.TipiRami_Fideiussioni; //Fideiussioni
        let pol: any = this.state.DatoFidePolizza;
        pol.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento * 1;
        this.setState({ DatoFidePolizza: pol });
        Ingr.Dato.DatiPolizza = JSON.stringify(this.state.DatoFidePolizza);
        //console.warn("TIPO PRODOTTO: ", Ingr.Dato.DataFine);
        return Ingr;
    }

    //private OnInvioCalcola(sender: BottoneAPI): any {
    private OnInvioCalcola(sender: any): any {
        //Usato sia da ChiamaWeb che ChiamaAPI
        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        Ingr.Dato = this.state.Dato.Dato;
        Ingr.Dato.ID_AnagContraente = this.ID_Anag;
        Ingr.Dato.ID_Polizza = this.ID_Polizza;
        Ingr.Dato.ID_TipoRamo = 1; //Fideiussioni
        let pol: any = this.state.DatoFidePolizza;
        pol.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento * 1;
        Ingr.Dato.DatiPolizza = JSON.stringify(this.state.DatoFidePolizza);
        return Ingr;
    }

    private OnInvioEstraiDati(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPI<string>();
        Ingr.Dato = this.state.DatoFidePolizza.CIG;
        return Ingr;
    }

    private RecuperaCifra(cifra: string): string {
        switch (cifra) {
            case "1":
                return this.state.in1;
            case "2":
                return this.state.in2;
            case "3":
                return this.state.in3;
            case "4":
                return this.state.in4;
            default:
                return "";
        }
    }

    private EmettiURL(): string {
        let URL: string = "/api/polizza/EmissioneCartaServizi";
        URL += "?id_Polizza=" + this.state.Dato.Dato.ID_Polizza.toString();
        URL += "&cifra1=" + this.RecuperaCifra(this._Cifra1);
        URL += "&cifra2=" + this.RecuperaCifra(this._Cifra2);
        URL += "&id_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento;
        return URL;
    }

    private MessaggioControlloEmissione: string = "";

    private ControlloEmissione(): boolean {
        let disabilitare: boolean = false;
        this.MessaggioControlloEmissione = "";
        for (var I in this.state.Dato.Info) {
            if (this.state.Dato.Info[I].Richiesto) {
                if (
                    Glob.ValoreDiDefault(this.state.Dato.Info[I].ID_TipoCampo) == this.state.DatoFidePolizza[this.state.Dato.Info[I].Campo] ||
                    this.state.DatoFidePolizza[this.state.Dato.Info[I].Campo].toString().length == 0
                ) {
                    disabilitare = true;
                    this.MessaggioControlloEmissione += Trad.Trad(this.state.Dato.Info[I].Etichetta) + " " + Trad.Trad("Richiesto") + ", ";
                }
            }
        }
        if (disabilitare) {
            this.MessaggioControlloEmissione = this.MessaggioControlloEmissione.substr(0, this.MessaggioControlloEmissione.length - 2);
        }

        if (this.state.Dato.Dato.FileJSON != undefined && this.state.Dato.Dato.FileJSON != "") {
            let datiFile: Dati.CDatiCheckListFileBase = new Dati.CDatiCheckListFileBase();
            datiFile = JSON.parse(this.state.Dato.Dato.FileJSON);

            if (!datiFile.Validato) {
                disabilitare = true;
                this.MessaggioControlloEmissione += " " + Trad.Trad("Non tutti i file necessari sono stati validati correttamente");
            }
        } else {
            if (this.ID_Polizza > 0) {
                this.MessaggioControlloEmissione += " " + Trad.Trad("Non tutti i file necessari sono stati validati correttamente");
            }
        }

        return disabilitare;
    }

    private ColoreStatoCSS(stato: string): string {
        if (stato == Glob.Tipi_PS_Preventivo) {
            return "has-warning";
        } else if (stato == Glob.Tipi_PS_Emessa) {
            return "has-success";
        } else {
            return "";
        }
    }

    private AbilitazioneEmissione(stato: string, invertito: boolean): string {
        let risultato: string = "";
        if (!invertito) {
            if (stato == Glob.Tipi_PS_Preventivo || stato == "") {
                risultato = "";
            } else {
                risultato = "hidden";
            }
        } else {
            if (stato == Glob.Tipi_PS_Preventivo || stato == "") {
                risultato = "hidden";
            } else {
                risultato = "";
            }
        }

        return risultato;
    }

    private Stampa(bozza: boolean) {
        let database: string = Glob.StampaDatabase();

        let URL: string = Glob.StampaURL();

        let preURLBozza = "";
        if (bozza) {
            preURLBozza = "BOZ-";
        }

        URL = URL + "?SessioneMyAr=" + Glob.GetSessione().Sessione;
        URL = URL + "&Chiave=" + this.state.Dato.Dato.ID_Polizza;
        URL = URL + "&Database=" + database;
        URL = URL + "&Data=" + Date.now();
        URL = URL + "&NomeFile=" + this.state.Dato.Dato.TipoProdotto;

        //TODO Leggere il tipo di prodotto direttamente dalla polizza
        //console.warn("TIPO PRODOTTO: ", this.state.Dato.Dato.ID_TipoProdotto);
        switch (this.state.Dato.Dato.ID_TipoProdotto) {
            case 1:
                URL = URL + "&Tipo=" + preURLBozza + "CADEF-";
                break;
            case 4:
                URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
                break;
            case 5:
                URL = URL + "&Tipo=" + preURLBozza + "CAANT-";
                break;
            case 6:
                URL = URL + "&Tipo=" + preURLBozza + "CARDS-";
                break;
            case 7:
                URL = URL + "&Tipo=" + preURLBozza + "CAONE-";
                break;
            case 9:
                URL = URL + "&Tipo=" + preURLBozza + "CACON-";
                break;
            case 10:
                URL = URL + "&Tipo=" + preURLBozza + "CAIVA-";
                break;
            case 11:
                URL = URL + "&Tipo=" + preURLBozza + "CA210-";
                break;
            //Iscrizione Albo rifiuti
            case 12:
                URL = URL + "&Tipo=" + preURLBozza + "CAISC-";
                break;
            //Gestione rifiuti
            case 13:
                URL = URL + "&Tipo=" + preURLBozza + "CARIF-";
                break;
            //ColtivazioneCave
            case 14:
                URL = URL + "&Tipo=" + preURLBozza + "CACOL-";
                break;
            //DaziDoganali
            case 15:
                URL = URL + "&Tipo=" + preURLBozza + "CADOG-";
                break;

            case 17:
                URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
                break;
            case 18:
                URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
                break;
            //Ripristino
            case 19:
                URL = URL + "&Tipo=" + preURLBozza + "CARIP-";
                break;
            //Attestazione capacità finanziaria autotrasportatori
            case 60:
                URL = URL + "&Tipo=" + preURLBozza + "CAACF-";
                break;
            //Energia rinnovabile
            case 61:
                URL = URL + "&Tipo=" + preURLBozza + "CAERN-";
                break;
            default:
                URL = "";
                break;
        }

        let CoAss: Dati.CDatoCoAssicurazione[] = [];
        if (typeof this.state.Dato.Dato.CoAssicurazioneJSON == "string") {
            CoAss = JSON.parse(this.state.Dato.Dato.CoAssicurazioneJSON);
        } else {
            CoAss = this.state.Dato.Dato.CoAssicurazioneJSON;
        }
        let Quota: number = 0;
        let ID_BinderCompagnia: number = 0;
        for (let i: number = 0; i < CoAss.length; i++) {
            if (CoAss[i].Delegataria) {
                ID_BinderCompagnia = CoAss[i].ID_BinderCompagnia;
            }
        }

        URL += ID_BinderCompagnia + "-PDF";

        window.open(URL + "-O", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
        Glob.Log(Glob.LogCat.Stampa, false, URL + "-O");
        if (!bozza) {
            Glob.Sleep(500);
            window.open(URL + "-C", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
            Glob.Log(Glob.LogCat.Stampa, false, URL + "-C");
            Glob.Sleep(500);
            window.open(URL + "-S", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
            Glob.Log(Glob.LogCat.Stampa, false, URL + "-S");
        }
    }

    //TODO Modificare/eliminare, usare i permessi
    private Temporaneo_PulsanteEmissioneVisibile(): string {
        let R = this.MessaggioControlloEmissione == "" ? "" : " " + this._VisibileScrittura;
        if (R == "") {
            if (this.ID_Polizza == 0) {
                R = " " + this._VisibileScrittura;
            }
        }
        if (R == "") {
            let Sessione = Glob.GetSessione();
            if (Sessione.Gruppi.indexOf("7") < 0 && Sessione.Gruppi.indexOf("8") < 0 && Sessione.Gruppi.indexOf("9") < 0) {
                R = " " + this._VisibileScrittura;
            }
        }
        return R;
    }

    private ApriPopupBenefiario(): void {
        let PopupBeneficiario: Window | null = window.open("/anagrafica/0?Popup=true", "PopupBeneficiario", "width=1920,height=1080");
        let self = this;
        if (PopupBeneficiario != null) {
            PopupBeneficiario.onbeforeunload = function() {
                if (PopupBeneficiario != null) {
                    let PopupID_Anag = PopupBeneficiario.document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                    if (PopupID_Anag != null && PopupID_Anag.value != null) {
                        self.state.DatoFidePolizza.ID_AnagBeneficiario = Number(PopupID_Anag.value);
                        self.setState({
                            DatoFidePolizza: self.state.DatoFidePolizza
                        });
                    }
                }
            };
        }
    }

    public render() {
        if (!this.ControlloAutorizzazione("PolizzaController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        this.ControlloEmissione();

        var caricaDocumenti = <div></div>;
        if (this.ID_Polizza > 0) {
            caricaDocumenti = (
                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                    <a href={"/file/" + this.state.Dato.Dato.ID_Polizza} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Documenti")}>
                        <i className="fa fa-archive"></i>
                        {Trad.Trad("Documenti")}
                    </a>
                </div>
            );
        }

        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(
            new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag)
        );
        infoContesto.push(
            new Dati.InfoContesto(
                Trad.Trad("Affidamento"),
                "/api/FideAffidamento/Contesto?ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento,
                "/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento
            )
        );

        let chiavi: number[] = [];

        chiavi.push((this.props.match.params as any).ID_Anag);
        chiavi.push((this.props.match.params as any).ID_FideAffidamento);
        chiavi.push(this.ID_Polizza);

        this.DateModificabili();

        //Aggiungere DataMinima={CDateTZLess.Today().ToDate()} su DataEffetto ma gestire il caso delle polizze già emesse

        return (
            <div>
                <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={e => this.OnChange(e)} />
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-file"></i>
                                </span>
                                <h3 className="kt-portlet__head-label">{Trad.Trad("Polizza")}</h3>
                            </div>
                        </div>
                        <div className="portlet__head-tools">
                            <ul className="kt-portlet__nav">
                                {caricaDocumenti}
                                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                    <a
                                        href={
                                            "/anagrafica/" +
                                            (this.props.match.params as any).ID_Anag +
                                            "/fideaffidamento/" +
                                            (this.props.match.params as any).ID_FideAffidamento +
                                            "/FidePolizza/" +
                                            this.ID_Polizza +
                                            "/coobbligato"
                                        }
                                        className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black"
                                        title={Trad.Trad("Coobbligati")}
                                    >
                                        <i className="fa fa-users"></i> {Trad.Trad("Coobbligati")}
                                    </a>
                                </div>
                                <div
                                    className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura}
                                    aria-expanded="true"
                                >
                                    <NavLink
                                        to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FidePolizza/0"}
                                        className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black"
                                        title={Trad.Trad("Nuovo")}
                                    >
                                        <i className="fa fa-plus"></i>
                                    </NavLink>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                        <div className="kt-portlet__body">
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-2">
                                    <label>{Trad.Trad("ID")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <input type="text" className="form-control" value={this.state.Dato.Dato.ID_Polizza} name="Dato.ID_Polizza" disabled />
                                        <span className="kt-input-icon__icon kt-input-icon__icon--right"></span>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>{Trad.Trad("Contraente")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <Tipo
                                            URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                            Campo="Dato.ID_AnagContraente"
                                            ID_ChiaveString={this.state.Dato.Dato.ID_AnagContraente.toString() || ""}
                                            OnAggiorna={this.OnChange}
                                            Disabilitato
                                            TradValori
                                            LinkSelezione="/anagrafica/"
                                        />
                                        <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                            <span>
                                                <i className="la la-user"></i>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <label>{Trad.Trad("Stato polizza")}</label>
                                    <div className={this.ColoreStatoCSS(this.state.Dato.Dato.ID_TipoPolizzaStato)}>
                                        <label>{Trad.Trad(this.state.Dato.Dato.StatoPolizza)}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-2">
                                    <label>{Trad.Trad("Polizza")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <input type="text" className="form-control" value={this.state.Dato.Dato.Polizza} name="Dato.Polizza" readOnly />
                                        <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                            <span>
                                                <i className="la la-file"></i>
                                            </span>
                                        </span>
                                    </div>
                                    {this.ControlloAutorizzazione("CodiceControlloVisualizza") && (
                                        <div>
                                            <span>{this.state.Dato.Dato.CodiceControllo}</span>
                                        </div>
                                    )}
                                </div>
                                <div className="col-lg-6">
                                    <label>{Trad.Trad("Prodotto")}</label>
                                    <Tipo
                                        URL={"/api/Tipi/Tipo?tabella=TipiProdottiFide&campo=TipoProdotto&parametri=" + (this.props.match.params as any).ID_FideAffidamento}
                                        Campo="Dato.ID_TipoProdotto"
                                        ID_ChiaveString={this.state.Dato.Dato.ID_TipoProdotto.toString() || ""}
                                        OnAggiorna={(e, v) => {
                                            this.OnChange(e, this.OnModificaURL(e, v));
                                        }}
                                        Disabilitato={this._DisabilitaSelezionaProdotto}
                                    />
                                </div>
                                <div className="col-lg-2">
                                    <label>{Trad.Trad("Data effetto")}</label>
                                    <div className={"form-control" + (!this._DataEffettoModificabile ? " disabilitato" : "")}>
                                        <CampoData
                                            ValoreInArrivo={this.ID_Polizza > 0}
                                            Name="Dato.DataEffetto"
                                            Id="Dato.DataEffetto"
                                            Valore={this.state.Dato.Dato.DataEffetto}
                                            OnChange={this.OnChangeDataEffetto}
                                            Disabilitato={!this._DataEffettoModificabile}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <label>{Trad.Trad("Data fine")}</label>
                                    <div className={"form-control" + (!this._DataFineModificabile ? " disabilitato" : "")}>
                                        <CampoData
                                            ValoreInArrivo={this.ID_Polizza > 0}
                                            Name="Dato.DataFine"
                                            Id="Dato.DataFine"
                                            Valore={this.state.Dato.Dato.DataFine}
                                            DataMinima={this.state.Dato.Dato.DataEffetto}
                                            OnChange={this.OnChange}
                                            Disabilitato={!this._DataFineModificabile}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 hidden">
                                <label>{Trad.Trad("POS")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo
                                        URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                        Campo="Dato.ID_AnagPOS"
                                        ID_ChiaveString={this.state.Dato.Dato.ID_AnagPOS.toString() || ""}
                                        OnAggiorna={this.OnChange}
                                        TradValori
                                        LinkSelezione="/anagrafica/"
                                    />
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span>
                                            <i className="la la-user"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>

                            {this.state.DatoFidePolizza.ATI && (
                                <div className="form-group kt-form login-form__group row">
                                    <div className="col-lg-12 text-center">{this.state.Dato.Dato.ContraenteATI}</div>
                                    <div className="col-lg-12">
                                        <Mandanti
                                            ColonnaCapogruppo={false}
                                            Id="DatoFidePolizza.MandantiJSON"
                                            Name="DatoFidePolizza.MandantiJSON"
                                            Value={this.state.DatoFidePolizza.MandantiJSON}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            )}

                            {this.state.BinderProdotto != undefined && this.state.BinderProdotto.length > 0 && (
                                <CoAssicurazione
                                    Id="Dato.CoAssicurazioneJSON"
                                    Name="Dato.CoAssicurazioneJSON"
                                    Value={this.state.Dato.Dato.CoAssicurazioneJSON}
                                    BinderProdotto={this.state.BinderProdotto}
                                    OnChange={this.OnChange}
                                />
                            )}

                            {this._BottoneBancaGareVisibile && (
                                <div className="form-group kt-form login-form__group row">
                                    <h3 className="kt-portlet__head-label">{Trad.Trad("BancaDatiGare")}</h3>
                                    <BancaDatiGare CIG={this.state.DatoFidePolizza.CIG} Aggiornare={this._AggiornaBancaDatiGare} UtilizzaBancaDataGare={this.UtilizzaBancaDatiGare} />
                                </div>
                            )}

                            {this.OnListaCampi()}

                            <ChiamaAPI Aggiornare={this._Incremento} URL={this._URLBinderProdotto} OnRis={(s, d, dn) => this.OnRisBinderProdotto(s, d, dn)} OnErrore={this.OnErrore} />

                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-12">
                                    <CheckListFile
                                        Aggiornare={this._NumeroBack}
                                        Id="Dato.FileJSON"
                                        Name="Dato.FileJSON"
                                        ID_Chiave={this.ID_Polizza}
                                        ChiaviRecupero={chiavi}
                                        ID_TipoFileRichiesto={this.state.Dato.Dato.ID_TipoFileRichiesto || ""}
                                        Value={this.state.Dato.Dato.FileJSON}
                                        OnChange={this.OnChange}
                                        Validato={false}
                                        Visibile={this.state.Dato.Dato.ID_Polizza > 0}
                                    />
                                </div>
                            </div>
                            <div className="kt-portlet__foot kt-portlet__foot--fit">
                                <div className="kt-form login-form__actions kt-form login-form__actions--left">
                                    <div className="modal fade" id="kt_modal_6" role="dialog" aria-labelledby="modalCartaServizi">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                                        {Trad.Trad("Carta Servizi")}
                                                    </h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body col-lg-12">
                                                    <div className="form-group kt-form login-form__group row">
                                                        <div className="col-lg-4">
                                                            <button className="btn btn-brand" type="button" name="indice">
                                                                {this._RichiestaCasella}
                                                            </button>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input
                                                                type="text"
                                                                name="in1"
                                                                value={this.state.in1}
                                                                maxLength={1}
                                                                className={"form-control text-center" + this.BloccoInput(this.state.in1Abl)}
                                                                onChange={e => this.OnChange(e)}
                                                                disabled={this.state.in1Abl}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input
                                                                type="text"
                                                                name="in2"
                                                                value={this.state.in2}
                                                                maxLength={1}
                                                                className={"form-control text-center" + this.BloccoInput(this.state.in2Abl)}
                                                                onChange={e => this.OnChange(e)}
                                                                disabled={this.state.in2Abl}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input
                                                                type="text"
                                                                name="in3"
                                                                value={this.state.in3}
                                                                maxLength={1}
                                                                className={"form-control text-center" + this.BloccoInput(this.state.in3Abl)}
                                                                onChange={e => this.OnChange(e)}
                                                                disabled={this.state.in3Abl}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input
                                                                type="text"
                                                                name="in4"
                                                                value={this.state.in4}
                                                                maxLength={1}
                                                                className={"form-control text-center" + this.BloccoInput(this.state.in4Abl)}
                                                                onChange={e => this.OnChange(e)}
                                                                disabled={this.state.in4Abl}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className={"btn btn-secondary " + this._VisibileScrittura} data-dismiss="modal">
                                                        {Trad.Trad("Chiudi")}
                                                    </button>
                                                    <BottoneAPI
                                                        Testo={Trad.Trad("Emetti")}
                                                        URL={this.EmettiURL()}
                                                        Metodo="POST"
                                                        OnClick={(s, d) => this.OnClickEmetti(s, d)}
                                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                        DataDismiss="modal"
                                                        Visibile={this._Scrittura}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group kt-form login-form__group row">
                                        <div className={"col-lg-12 kt--align-left"}>{this.MessaggioControlloEmissione}</div>
                                        <div className={"col-lg-12 kt--align-left"}>
                                            <ChiamaAPI Aggiornare={this._Incremento} URL={this._URLInfoPolizza} OnRis={(s, d, dn) => this.OnRisDatiPolizzaNuova(s, d, dn)} OnErrore={this.OnErrore} />
                                            <ChiamaAPI
                                                Aggiornare={this.state.Dato.Dato.ID_TipoProdotto + this._Incremento}
                                                URL={this._URLLimiteImportoGarantito}
                                                OnRis={(s, d, dn) => this.OnRisLimiteAffidamento(s, d, dn)}
                                                OnErrore={this.OnErrore}
                                            />
                                            <ChiamaAPI
                                                Aggiornare={this.state.Dato.Dato.ID_TipoProdotto + this._Incremento}
                                                URL={this._URLLimiteImportoGarantitoDeroga}
                                                OnRis={(s, d, dn) => this.OnRisLimiteDeroga(s, d, dn)}
                                                OnErrore={this.OnErrore}
                                            />
                                            <ChiamaAPI
                                                Aggiornare={1}
                                                URL={"/api/polizza/?id_Polizza=" + this.ID_Polizza + "&id_AnagContraente=" + this.state.Dato.Dato.ID_AnagContraente}
                                                OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                                                OnErrore={this.OnErrore}
                                            />

                                            <div className={"divtabella " + this.AbilitazioneEmissione(this.state.Dato.Dato.ID_TipoPolizzaStato, false)}>
                                                <BottoneAPI
                                                    Alt={Trad.Trad("Salva")}
                                                    Icona="fa fa-save"
                                                    Default
                                                    Testo={Trad.Trad("Salva")}
                                                    ClasseAttivo="btn btn-brand"
                                                    ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                    URL="/api/polizza/salvapolizza"
                                                    Metodo="POST"
                                                    OnInvio={s => this.OnInvioSalva(s)}
                                                    OnClick={(s, d) => this.OnClickSalva(s, d)}
                                                    OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                    Visibile={this._Scrittura}
                                                />
                                            </div>
                                            <div className={"divtabella " + this.AbilitazioneEmissione(this.state.Dato.Dato.ID_TipoPolizzaStato, false)}>
                                                <BottoneAPI
                                                    Alt={Trad.Trad("Calcola")}
                                                    Icona="fa fa-calculator"
                                                    Testo={Trad.Trad("Calcola")}
                                                    ClasseAttivo="btn btn-warning"
                                                    ClasseAttesa="btn kt-btn btn-warning kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                    URL="/api/polizza/fidecalcola"
                                                    Metodo="POST"
                                                    OnInvio={s => this.OnInvioCalcola(s)}
                                                    OnClick={(s, d) => this.OnClickCalcola(s, d)}
                                                    OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                    Visibile={this._Scrittura}
                                                    Attivo={!this.GetDatiCambiati()}
                                                />
                                            </div>
                                            <div
                                                className={"divtabella " + this.AbilitazioneEmissione(this.state.Dato.Dato.ID_TipoPolizzaStato, false) + this.Temporaneo_PulsanteEmissioneVisibile()}
                                                data-toggle="modal"
                                                data-target="#kt_modal_6"
                                            >
                                                <button type="button" className="btn btn-success" title={this.MessaggioControlloEmissione}>
                                                    <span>
                                                        <i className="fa fa-thumbs-up"></i>
                                                        <span>{Trad.Trad("Emetti")}</span>
                                                    </span>
                                                </button>
                                            </div>
                                            <div className={"divtabella " + this.AbilitazioneEmissione(this.state.Dato.Dato.ID_TipoPolizzaStato, true)}>
                                                <button type="button" className="btn btn-accent" onClick={() => this.Stampa(false)} title={Trad.Trad("Stampa")}>
                                                    <span>
                                                        <i className="fa fa-file-pdf"></i>
                                                        <span> {Trad.Trad("Stampa")}</span>
                                                    </span>
                                                </button>
                                            </div>
                                            <div className={"divtabella " + this.AbilitazioneEmissione(this.state.Dato.Dato.ID_TipoPolizzaStato, false)}>
                                                <button type="button" className="btn btn-accent" onClick={() => this.Stampa(true)} disabled={this.GetDatiCambiati()} title={Trad.Trad("Stampa bozza")}>
                                                    <span>
                                                        <i className="fa fa-file"></i>
                                                        <span> {Trad.Trad("Stampa bozza")}</span>
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="divtabella">
                                                <Deroga Id="Deroga" Name="Deroga" OnChange={() => { }} Tipo={Glob.Tipi_DT_Polizza} Valore={this.state.ListaCampiDeroga} ID={this.ID_Polizza} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/FidePolizza.tsx